module.exports = __webpack_public_path__ + "Group 15697.d6d713c1f12b6f8877d4.png";